import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3735643423/src/globallynx-report-system/app/context/client-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3735643423/src/globallynx-report-system/components/atoms/Loader.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3735643423/src/globallynx-report-system/styles/globals.scss");
